import { selectDoc, event, selectAll, select } from "../utils/utils";

export class AccountNav {
  constructor(el) {
    if (el) {
      this.init(el);
    }
  }

  init(el) {
    this.el = el;
    this.props();
    this.render();
  }

  props() {
    this.accountItem = selectAll('.js-navItem');
    this.accountContent = selectAll('.js-accountContent');
  }

  render() {
    this.navSelect();
  }

  navSelect() {
    const navEl = this.accountItem;

    for(const nav of navEl) {
      nav.addEventListener('click', () => {
        select(nav.closest('.js-accountNav'),'.active').classList.remove('active');
        nav.classList.add('active');
        Array.from(this.accountContent).find(content=> {
          content.dataset.section === nav.dataset.nav ? content.classList.add('active') : content.classList.remove('active');
        })
      })
    }
  }
}
